import React from 'react';
import PropTypes from 'prop-types';
import CopyShare from '../CopyShare';
import styles from './SocialLinks.module.scss';

export const SocialLinksPropTypes = {
  url: PropTypes.string.isRequired
};

function SocialLinks({ url, footerPage }) {
  return (
    <ul className={styles.socials} data-testid="SocialLinks">
      {footerPage ?
        <>
          <li>
            <a className={styles.footerTwitter} href={`https://www.twitter.com/share?url=${url}`} data-uxa-log={`social_link_twitter`} data-uxa-interactions="click shown">
              <span className="sr-only">Twitter</span>
            </a>
          </li>
          <li>
            <a
              className={styles.footerFacebook}
              data-uxa-log={`social_link_facebook`}
              data-uxa-interactions="click shown"
              href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
              data-testid="SocialLinks-facebook">
              <span className="sr-only">Facebook</span>
            </a>
          </li><li>
            <a className={styles.footerYoutube} href={`https://www.youtube.com/user/dropbox/?url=${url}`} data-uxa-log={`social_link_youtube`} data-uxa-interactions="click shown">
              <span className="sr-only">Linkedin</span>
            </a>
          </li></> :
        <><li>
          <a
            className={styles.facebook}
            data-uxa-log={`social_link_facebook`}
            data-uxa-interactions="click shown"
            href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
            data-testid="SocialLinks-facebook">
            <span className="sr-only">Facebook</span>
          </a>
        </li><li>
            <a className={styles.twitter} href={`https://www.twitter.com/share?url=${url}`} data-uxa-log={`social_link_twitter`} data-uxa-interactions="click shown">
              <span className="sr-only">Twitter</span>
            </a>
          </li><li>
            <a className={styles.linkedin} href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`} data-uxa-log={`social_link_linkedin`} data-uxa-interactions="click shown">
              <span className="sr-only">Linkedin</span>
            </a>
          </li><li>
            <CopyShare url={url} />
          </li></>
      }
    </ul>

  );
}

SocialLinks.propTypes = SocialLinksPropTypes;

export default SocialLinks;